import { useTableActionContext } from '@aibees/elephant/context/table-action/context';
import { SearchModality } from '@aibees/elephant/feature/search-table-company/hooks/types';
import { useGetCreditsAmountTypeOnActionPopup } from '@aibees/elephant/hooks/use-get-credits-amount-type-on-action-popup';
import { classnames } from '@aibees/shared/utils';
import { AlertTitle, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportWarningSavedProps as Props } from './types';

export const ExportWarningSaved = memo(({ className }: Props) => {
  // Effective modality: for a single-record flow this follows the record's own
  // saved state rather than whichever tab the table is on.
  const { effectiveModality } = useTableActionContext();
  const { basicPeople, aiPeople } = useGetCreditsAmountTypeOnActionPopup();

  const saved = effectiveModality === SearchModality.SAVED;
  const shouldShow = (basicPeople || aiPeople) && saved;

  if (!shouldShow) {
    return null;
  }

  return (
    <Styled.Wrapper
      className={classnames('ExportWarningSaved', className)}
      sx={SX.root}
      severity="default"
      variant="outlined"
    >
      <AlertTitle sx={{ fontSize: '14px', fontWeight: 'bold' }}>
        Before you hit Export pulls your current Saved Records
      </AlertTitle>

      <Stack>
        <Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              If your Records still need updates?
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Click Cancel.
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Open Enrich ▸ and run
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Update Job Changes,
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Update Profile Insights
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Run Email Enrichment & Re-Verification.{' '}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Done recently? Skip these steps—you’re good to export.{' '}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Styled.Wrapper>
  );
});

ExportWarningSaved.displayName = 'ExportWarningSaved';
